<template>
  <div class="splitWithdrawConfirmPop">
    <div class="card">
      <img src="../../assets/images/WithdrawalSuccessful/close.png" alt="" class="close" @click="close">
      <div class="splitWithdrawTitle">{{ $t('lang.account.splitWithdrawTip') }}</div>
      <div class="splitWithdrawOptionBox">
        <div class="withdrawOptionItemCard" @click="activeSplitWithdrawOption(0)" :style="`background-image:url(${splitWithdrawOptionItemActive === 0 ? withdrawOptionItemBgActive: withdrawOptionItemBg});`">
          <img :src="withdrawOptionItemCardIcon2" alt=""  class="withdrawOptionItemCardIcon">
          <div class="contentBox">
            <div class="title">{{$t('lang.account.withdrawing') }} <span>₹{{withdrawAmount}}</span>  </div>
            <div class="largeWithdrawalsItemTip">{{ $t('lang.account.withdrawalsAsterItemTip') }}</div>
          </div>
        </div>
        <div class="withdrawOptionItemCard" @click="activeSplitWithdrawOption(1)" :style="`background-image:url(${splitWithdrawOptionItemActive === 1 ? withdrawOptionItemBgActive: withdrawOptionItemBg});`">
          <img :src="withdrawOptionItemCardIcon2" alt=""  class="withdrawOptionItemCardIcon">
          <div class="contentBox">
            <div class="title">{{$t('lang.account.withdrawing') }} <span>₹{{getSplitWithdrawAmount(withdrawAmount)}}</span>  </div>
            <div class="largeWithdrawalsItemTip">{{ $t('lang.account.largeWithdrawalsItemTip') }}</div>
          </div>
        </div>
      </div>
      <div class="submitBtn" @click="withDraw()">{{splitWithdrawOptionItemActive === 1 ? $t('lang.account.fastWithdrawal') : $t('lang.account.slowWithdrawal')

        }}
      </div>
    </div>
  </div>
</template>
<script>
import withdrawOptionItemBg from '@/assets/images/account/withdrawOptionItemBg-pop.png'
import withdrawOptionItemBgActive from '@/assets/images/account/withdrawOptionItemBgActive-pop.png'
import withdrawOptionItemCardIcon1 from '@/assets/images/account/withdrawOptionItemCardIcon1.png'
import withdrawOptionItemCardIcon2 from '@/assets/images/account/withdrawOptionItemCardIcon2.png'
export default {
  props: ['withdrawAmount', 'withDraw', 'close', 'SplitAmount'],
  data () {
    return {
      splitWithdrawOptionItemActive: 1,
      withdrawAccount: null,
      withdrawOptionItemBg,
      withdrawOptionItemBgActive,
      withdrawOptionItemCardIcon1,
      withdrawOptionItemCardIcon2
    }
  },
  mounted () {
    this.$emit('setSplitWithdrawOptionItemActive', this.splitWithdrawOptionItemActive)
  },
  methods: {
    activeSplitWithdrawOption (splitWithdrawOptionItemActive) {
      this.splitWithdrawOptionItemActive = splitWithdrawOptionItemActive
      this.$emit('setSplitWithdrawOptionItemActive', this.splitWithdrawOptionItemActive)
    },
    getSplitWithdrawAmount (withdrawAmount) {
      let splitNums = 0
      if (withdrawAmount && withdrawAmount > this.SplitAmount) {
        splitNums = Math.ceil((withdrawAmount / this.SplitAmount))
        return withdrawAmount + ' / ' + splitNums
      } else {
        return withdrawAmount
      }
    }
  }
}
</script>
<style scoped lang="less">
.splitWithdrawConfirmPop{
  height: 100vh;
  width: 100vw;
  position:  fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content:  center;
  background-color: rgba(0,0,0,.82);
  z-index: 999;
  .card{
    width: 86.666vw;
    height: 87.222vw;
    border-radius: 4.166vw;
    background: linear-gradient(to right, #151715, #202020);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .splitWithdrawTitle{
      font-size: 4.444vw;
      color: #FFFFFF;
      font-weight: 700;
      margin-top: 10.277vw;
    }
    .splitWithdrawOptionBox{
      display: flex;
      flex-direction: column;
      .withdrawOptionItemCard{
        width: 78.611vw;
        height: 15.833vw;
        background-size: 100% 100%;
        display:  flex;
        align-items: center;
        gap: 3.775vw;
        flex-shrink: 0;
        //transition: all 0.1s ease-in-out;
        position: relative;
        &:nth-child(1) {
          margin-top: 9.444vw;
        }
        &:nth-child(2) {
          margin-top: 4.722vw;
        }
        .withdrawOptionItemCardIcon{
          height: 6.666vw;
          width: 5.483vw;
          position:  relative;
          top: -1vw;
          margin-left: 3.888vw;
        }
        .contentBox{
          height: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          gap: 2.333vw;
          .title{
            font-size: 3.611vw;
            font-weight: bold;
            color: #D0C3C3;
            display: flex;
            align-items: center;
            gap: 2vw;
            span{
              color: #F6D9AA;
              display: block;
              position: relative;
              top: 0.5vw;
            }
          }
          .largeWithdrawalsItemTip{
            font-size: 3.055vw;
            font-weight: bold;
            color: #8E0505;

          }
        }
      }
    }
    .submitBtn{
      font-size: 3.472vw;
      color: #000;
      font-weight: 700;
      height: 10.833vw;
      width: 79.027vw;
      line-height: 10.833vw;
      text-align: center;
      margin-top: 10.555vw;
      border-radius: 1.944vw;
      background-color: #F6D9AA;
    }
    .close{
      height: 4.055vw;
      width: 4.055vw;
      position:  absolute;
      right: 2vw;
      top: -9vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SplitWithdrawConfirm/index.vue